
import Vue from "vue";
// import { Ability, AbilityBuilder } from "@casl/ability";

export default Vue.extend({
  name: "Login",

  data: () => ({
    logo: require("@/assets/images/logos/logo.png") as any,
    model: {
      email: "" as string,
      phone: "" as string,
      name: "" as string
    },
    errorMessage: "" as string,

    showPassword: false as boolean,
    forgot: false as boolean
  }),

  computed: {
    PasswordType(): string {
      if (this.showPassword) {
        return "text";
      }
      return "password";
    },
    rules() {
      return {
        email: [
          (v: string): boolean | string =>
            !!v || (this.$t("auth.validation.required") as string)
        ],
        password: [
          (v: string): boolean | string =>
            !!v.length || (this.$t("auth.validation.required") as string)
        ]
      };
    }
  },

  methods: {
    async signIn(): Promise<void> {
      try {
        if (await (this.$refs.form as any).validate()) {
          await this.$API.auth().register(this.model);
          await this.$store.dispatch(
            "alert/showSuccess",
            "Пользователь успешно создан!"
          );
          await this.$router.push("/");
        }
      } catch (e) {
        this.errorMessage = e.message;
      }
    },
    async forgotPassword(): Promise<void> {
      try {
        const resp = await this.$API.auth().forgot({ email: this.model.email });
        await this.$store.dispatch("alert/showSuccess", (resp as any).message);
        this.forgot = false;
      } catch (e) {
        this.errorMessage = `test`;
      }
    },
    togglePasswordType(): void {
      this.showPassword = !this.showPassword;
      this.errorMessage = "";
    },
    toggleForgot(): void {
      this.forgot = !this.forgot;
    },
    submitForm(): void {
      if (this.forgot) {
        this.forgotPassword();
      } else {
        this.signIn();
      }
    }
  }
});
